module.exports = __webpack_public_path__ + "img/micronfooter.a0e6af44.svg";